<div class="fvef container">
  <div class="flip-card">
    <div class="flip-inner" #flipInner [class.is-edit]="isEdit">

      <!-- Frente: vista plana dentro de la ventana blanca -->
      <div class="flip-face front" #frontFace>
  <div class="form-wrapper ticket bg-white dark:bg-surface-900 text-gray-800 dark:text-gray-100 border border-gray-200 dark:border-gray-700" [class.ticket-notches]="ticketNotches">
          <div class="form-header">
            <div class="header-actions">
              @if (editButton) {
                <button type="button" class="btn btn-secondary" (click)="toggleEdit()">
                  <i class="pi pi-pencil"></i> 
                  &nbsp;&nbsp;Editar
                </button>
              }
            </div>
            <h1 class="form-title">{{ title }}</h1>
            <p class="form-subtitle">{{ subtitle }}</p>
          </div>
          @for (section of sections; track section) {
              <fieldset class="border border-gray-300 dark:border-gray-700 rounded-2xl p-4 mb-6">
              <legend class="fvef-legend">{{ section.title }}</legend>
              <div class="form-grid">
                @for (field of section.fields; track field) {
                  @if (shouldShow(field)) {
                  <div class="form-group">
                    <div class="form-label">{{ field.label }}</div>
                      <div class="form-static">
                        {{
                          (field.type === 'select' || field.type === 'autocomplete')
                            ? getOptionLabel(field, values[field.id])
                            : (
                              field.type === 'checkbox'
                                ? (values[field.id] ? 'Sí' : 'No')
                                : (
                                  field.type === 'date'
                                    ? (
                                        field.id === 'licencia_fecha_inicio' || field.id === 'licencia_fecha_fin' || field.id === 'licencia_fecha_incorporacion' || field.id === 'licencia_hasta' || field.id === 'fecha_desde' || field.id === 'fecha_hasta' || field.id === 'fecha_carga' || field.id === 'fecha_modificacion' || field.id === 'fecha_solicitud' || field.id === 'franco_desde' || field.id === 'hasta' || field.id === 'fecha_requerida'
                                          ? ((values[field.id] | date:'dd/MM/yyyy') || '—')
                                          : ((values[field.id] | date:'dd/MM/yyyy, HH:mm') || '—')
                                      )
                                    : (
                                        field.id === 'distancia_km'
                                          ? ((values[field.id] ?? '') + (values[field.id] != null ? ' km' : ''))
                                          : (values[field.id] ?? '—')
                                      )
                                )
                              )
                        }}
                      </div>
                  </div>
                  }
                }
              </div>
            </fieldset>
          }
        </div>
      </div>

      <!-- Dorso: edición con inputs dentro de la misma ventana blanca -->
      <div class="flip-face back" #backFace>
  <div class="form-wrapper ticket edit-mode border-cyan-800 dark:border-white text-gray-800 dark:text-gray-100" [class.ticket-notches]="ticketNotches">
          <div class="form-header">
            <div class="header-actions">
              <button type="button" class="btn btn-secondary" (click)="toggleEdit()">
                <i class="pi pi-undo"></i>
                &nbsp;&nbsp;Volver
              </button>
            </div>
            <h1 class="form-title">Editar</h1>
            <p class="form-subtitle">Completa o corrige los datos</p>
            <div class="edit-badge"><i class="pi pi-pencil"></i>&nbsp;Modo edición</div>
          </div>
          @if (bannerMessage) {
            <div class="p-3 mb-3 border-round flex align-items-center gap-2"
                 [ngClass]="{
                   'surface-50 text-gray-700 border-1 border-gray-300': !bannerSeverity || bannerSeverity==='info',
                   'surface-50 text-orange-700 border-1 border-orange-300': bannerSeverity==='warn',
                   'surface-50 text-green-700 border-1 border-green-300': bannerSeverity==='success',
                   'surface-50 text-red-700 border-1 border-red-300': bannerSeverity==='error'
                 }">
              <i class="pi" [ngClass]="{
                'pi-info-circle text-gray-600': !bannerSeverity || bannerSeverity==='info',
                'pi-exclamation-triangle text-orange-600': bannerSeverity==='warn',
                'pi-check-circle text-green-600': bannerSeverity==='success',
                'pi-times-circle text-red-600': bannerSeverity==='error'
              }"></i>
              <span>{{ bannerMessage }}</span>
            </div>
          }
          <form (ngSubmit)="onSubmit()">
            <p-fluid>
            @for (section of editableSections; track section) {
              <section class="form-section">
                <h2 class="section-title">{{ section.title }}</h2>
                <div class="form-grid">
                  @for (field of section.fields; track field) {
                    <div class="form-group">
                      @if ((field.type || 'text') === 'textarea') {
                        <p-floatLabel class="w-full" variant="on">
                          <textarea pInputTextarea rows="3" class="w-full bg-white dark:bg-surface-900" [id]="field.id" name="{{field.id}}" [placeholder]="field.placeholder || ''" [readOnly]="field.readonly" [(ngModel)]="values[field.id]" (ngModelChange)="onInputChange(field.id, $event)"></textarea>
                          <label for="{{field.id}}">{{ field.label }}</label>
                        </p-floatLabel>
                      } @else if ((field.type || 'text') === 'select') {
                        <p-floatLabel class="w-full" variant="on">
                          <p-select class="w-full" inputStyleClass="w-full bg-white dark:bg-surface-900" [options]="field.options || []" optionLabel="label" optionValue="value" [(ngModel)]="values[field.id]" [ngModelOptions]="{ standalone: true }" (ngModelChange)="onInputChange(field.id, $event)" [disabled]="field.readonly ?? false" inputId="{{field.id}}" [showClear]="true" [appendTo]="'body'" filter>
                          </p-select>
                          <label for="{{field.id}}">{{ field.label }}</label>
                        </p-floatLabel>
                      } @else if ((field.type || 'text') === 'autocomplete') {
                        <p-floatLabel class="w-full" variant="on">
                          <p-autoComplete class="w-full"
                                          inputStyleClass="w-full bg-white dark:bg-surface-900"
                                          inputId="{{field.id}}"
                                          [suggestions]="acSuggestions[field.id] || []"
                                          [(ngModel)]="acModel[field.id]"
                                          [ngModelOptions]="{ standalone: true }"
                                          (completeMethod)="onAutoComplete(field, $event)"
                                          optionLabel="label"
                                          [dropdown]="true"
                                          [forceSelection]="true"
                                          [showClear]="true"
                                          (onSelect)="onAutoSelect(field, $event)"
                                          (onClear)="onAutoClear(field)"
                                          (onBlur)="!acModel[field.id]?.value ? onAutoClear(field) : null"
                                          [appendTo]="'body'"
                                          [placeholder]="field.placeholder || ''"></p-autoComplete>
                          <label for="{{field.id}}">{{ field.label }}</label>
                        </p-floatLabel>
                      } @else if ((field.type || 'text') === 'date') {
                        @if (field.readonly) {
                          <p-floatLabel class="w-full" variant="on">
                            <input pInputText class="w-full bg-white dark:bg-surface-900"
                                   type="text"
                                   [id]="field.id"
                                   name="{{field.id}}"
                                   [readOnly]="true"
                                   [value]="values[field.id] | date:'dd/MM/yyyy'" />
                            <label for="{{field.id}}">{{ field.label }}</label>
                          </p-floatLabel>
                        } @else {
                          <p-floatLabel class="w-full" variant="on">
                            <p-datepicker
                              inputId="{{field.id}}"
                              class="w-full"
                              [inputStyleClass]="'w-full bg-white dark:bg-surface-900'"
                              [(ngModel)]="values[field.id]"
                              [ngModelOptions]="{ standalone: true }"
                              [showIcon]="true"
                              iconDisplay="input"
                              [appendTo]="'body'"
                              [placeholder]="field.placeholder || ''"
                              dateFormat="dd/mm/yy"
                              [showTime]="!(field.id === 'licencia_hasta' ||field.id === 'licencia_fecha_incorporacion' || field.id === 'licencia_fecha_fin' || field.id === 'fecha_desde' || field.id === 'fecha_hasta'||  field.id === 'licencia_fecha_inicio' || field.id === 'fecha_carga' || field.id === 'fecha_modificacion' || field.id === 'fecha_solicitud' || field.id === 'franco_desde' || field.id === 'hasta' || field.id === 'fecha_requerida')"
                              hourFormat="24"
                            >
                            </p-datepicker>
                            <label for="{{field.id}}">{{ field.label }}</label>
                          </p-floatLabel>
                        }
                      } @else if ((field.type || 'text') === 'checkbox') {
                        <div class="w-full flex items-center gap-2">
                          <p-checkbox
                            [binary]="true"
                            [inputId]="field.id"
                            [(ngModel)]="values[field.id]"
                            [ngModelOptions]="{ standalone: true }"
                            (ngModelChange)="onInputChange(field.id, $event)"
                            [disabled]="field.readonly ?? false"
                          ></p-checkbox>
                          <label for="{{field.id}}">{{ field.label }}</label>
                        </div>
                      } @else {
                        <p-floatLabel class="w-full" variant="on">
                          @if (field.id === 'fecha_solicitud_display') {
                            <!-- Mostrar la fecha preformateada tal cual (dd/MM/yyyy) -->
                            <input pInputText class="w-full bg-white dark:bg-surface-900"
                                   type="text"
                                   [id]="field.id"
                                   name="{{field.id}}"
                                   [readOnly]="true"
                                   [value]="values[field.id]" />
                          } @else if (field.id === 'fecha_solicitud' || field.id === 'fecha_carga' || field.id === 'fecha_modificacion') {
                            <!-- Para fechas como Date, usar pipe dd/MM/yyyy -->
                            <input pInputText class="w-full bg-white dark:bg-surface-900"
                                   type="text"
                                   [id]="field.id"
                                   name="{{field.id}}"
                                   [readOnly]="true"
                                   [value]="values[field.id] | date:'dd/MM/yyyy'" />
                          } @else {
                            <input pInputText class="w-full bg-white dark:bg-surface-900"
                                   [type]="field.type || 'text'"
                                   [attr.step]="(field.type === 'time') ? '1' : null"
                                   [id]="field.id"
                                   name="{{field.id}}"
                                   [placeholder]="field.placeholder || ''"
                                   [readOnly]="field.readonly"
                                   [(ngModel)]="values[field.id]"
                                   (ngModelChange)="onInputChange(field.id, $event)" />
                          }
                          <label for="{{field.id}}">{{ field.label }}</label>
                        </p-floatLabel>
                      }
                    </div>
                  }
                </div>
              </section>
            }
            </p-fluid>
            <div class="form-actions">
              <button type="button" class="btn btn-secondary" (click)="onCancel()" [disabled]="isSubmitting">Cancelar</button>
              <button type="submit" class="btn btn-primary" [disabled]="isSubmitting || saveDisabled">
                @if (!isSubmitting) { Guardar }
                @if (isSubmitting) {
                  <span class="flex items-center gap-2">
                    <span class="spinner"></span>
                    Guardando...
                  </span>
                }
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
